import React, { Component } from 'react'
import {  Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import _ from "lodash";


 class SubstituteModal extends Component {
    render() {
        const { isOpen, modalHide, SubstituteData } = this.props
        return (
                    <Modal
                    isOpen={isOpen}
                    toggle={() => modalHide('SubstituteModalshow')}
                    className='custom-modal confirm-transfer-modal'
                    >
                        
                        <ModalBody className='substitute-modal-body'>
                                <div className="substitute-modal-header">
                                    <i className="icn" />
                                    <h3 className='title'>Automated substitution has been done</h3>
                                </div>
                                <div className="substitute-modal-content">
                                    <div className="substitute-tbl-head">
                                        <div className="tbl-col">
                                            <i className="icon-up" />
                                            Sub Out
                                        </div>
                                        <div className="tbl-col">
                                            <i className="icon-up in" />
                                            Sub In
                                        </div>
                                    </div>
                                    
                                    {
                                        
                                      _.map(SubstituteData, (item, idx) => {
                                        if (item.in && item.out) {
                                    
                                            return (
                                                <div className="substitute-tbl-row" key={idx}>
                                                    <div className="tbl-col">
                                                        <figure className="jersy-thumb">
                                                            <img src={item.out.jersey} alt={item.out.full_name + " Jersey"} />
                                                        </figure>
                                                        <div className="overflow">
                                                            <div className="text-bold text-capitalize text-truncate">{item.out.full_name}</div>
                                                            <div className="text-muted text-uppercase small text-truncate">{item.out.team_abbr_lang}</div>
                                                        </div>
                                                    </div>
                                                    <div className="tbl-col">
                                                        <div className="overflow">
                                                            <div className="text-bold text-capitalize text-truncate">{item.in.full_name}</div>
                                                            <div className="text-muted text-uppercase small text-truncate">{item.in.team_abbr_lang}</div>
                                                        </div>
                                                        <figure className="jersy-thumb">
                                                            <img src={item.in.jersey} alt={item.in.full_name + " Jersey"} />
                                                        </figure>
                                                    </div>
                                                </div>
                                            )
                                        } else {
                                            return null; 
                                        }
                                    })
                                    }
                                </div>
                        </ModalBody>
                        <ModalFooter className='footer-cls-modal'>
                            <Button className='confirm-changes' block onClick={() => modalHide('SubstituteModalshow')} type='button' >Ok</Button>
                        </ModalFooter>
                    </Modal>
            
        )
    }
}

export default SubstituteModal